import axios from 'axios';

export default {
  async CREATE_organization({ commit, dispatch }, organization) {
    const dbOrganization = await axios.post('/api/organization', organization);
    commit('SET_organization', dbOrganization);
    dispatch('LOAD_organizations');
    return dbOrganization;
  },
  async UPDATE_organization({ commit }, organization) {
    await axios.put('/api/organization', organization);
    commit('SET_organization', organization);
  },
  async LOAD_organizations({ commit }) {
    const result = await axios.get('/api/organization');
    commit('SET_organizations', result.data);
    commit('SET_organization', result.data[0]);
  },
  async LOAD_allOrganizations({ commit }) {
    const result = await axios.get('/api/organization');
    commit('SET_organizations', result.data);
    commit('SET_organization', result.data[0]);
  },
};
